module.exports = __webpack_public_path__ + "static/media/drmario.f9f72ea2.png";